const config = {
  apiKey: "your-api-key",
  authDomain: "your-auth-domain",
  apiBaseUrl: "https://droplet.dipan.dev/api",
};

export default config;
